module.exports = __webpack_public_path__ + "static/media/K.90ee53dd.png";